import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Normalizes client routes:
// - removes trailing slash except for root
// - collapses duplicate slashes
// Keeps query/hash intact and avoids loops
export default function RouteCanonicalizer() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const { pathname, search, hash } = location;
		if (!pathname) return;

		let normalized = pathname.replace(/\/+$/g, ''); // remove trailing slashes
		if (normalized === '') normalized = '/';
		normalized = normalized.replace(/\/{2,}/g, '/'); // collapse duplicate slashes

		if (normalized !== pathname) {
			// Use replace to avoid history stack growth
			navigate({ pathname: normalized, search, hash }, { replace: true });
		}
	}, [location, navigate]);

	return null;
}











